import { Tables } from "@/lib/supabase/supabase_types_override";
import { supabase } from "@/lib/supabase/supabaseClient";

export const leaveOrganization = async (orgId: Tables<'organisation'>['id']) => {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) throw new Error("User not found");
    await supabase
        .from('organisation_members')
        .delete()
        .eq('organisation_id', orgId)
        .eq('user_id', user.id)
        .throwOnError();
}